import { render } from "./AddPositionControl.vue?vue&type=template&id=544af905"
import script from "./AddPositionControl.vue?vue&type=script&lang=js"
export * from "./AddPositionControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__